module.exports = __webpack_public_path__ + "img/bg.4c419e1e.png";